// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.global_container {
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 7px;
}

.app-container {
  position: relative;
}

.loader-css-class {
  --background: #261bff;
  --spinner-color: #ffffff;
}

.footer-container {
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5000;
  background-color: var(--input-background);
  color: var(--input-text-color);
  padding-top: 5px;
  padding-bottom: 5px;
}

main {
  max-width: min(90%, 1520px);
  margin-inline: auto;
  margin-bottom: 60px;
  min-height: calc(100vh - 138px);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,wBAAA;AAHF;;AAOA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,yCAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AAJF","sourcesContent":[":host{\r\n  display: block;\r\n  min-height: 100vh;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n}\r\n\r\n\r\n\r\n.global_container {\r\n  margin-left: 10%;\r\n  margin-right: 10%;\r\n  margin-bottom: 7px;\r\n  //background: rgb(228, 228, 228) !important;\r\n  //background: linear-gradient(0deg, rgba(228, 228, 228, 1) 0%, rgba(89, 177, 199, 1) 12%, rgba(51, 99, 130, 1) 100%) !important;\r\n}\r\n\r\n.app-container{\r\n  position: relative;\r\n}\r\n\r\n.loader-css-class {\r\n  --background: #261bff;\r\n  --spinner-color: #ffffff;\r\n}\r\n\r\n\r\n.footer-container {\r\n  position: fixed;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  left: 0;\r\n  bottom: 0;\r\n  right:0;\r\n  z-index: 5000;\r\n  background-color: var(--input-background);\r\n  color: var(--input-text-color);\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\nmain{\r\n  max-width: min(90%, 1520px);\r\n  margin-inline: auto;\r\n  margin-bottom: 60px;\r\n  min-height: calc(100vh - 138px);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
